var render = function render(){var _vm=this,_c=_vm._self._c;return _c('view_app',{staticClass:"view_app",class:{
        single_application_solution:
            _vm.App.root_activated_view == 'single_application_solution'
    }})
}
var staticRenderFns = []

export { render, staticRenderFns }